package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.radar.options.plugins.TooltipOptions

@RadarDsl
class TooltipScope {
    var enabled: Boolean = true
    var mode: String? = null
    var intersect: Boolean? = null
    var tooltipBackgroundColor: ChartColor? = null
    var titleColor: ChartColor? = null
    var bodyColor: ChartColor? = null
    var borderColor: ChartColor? = null
    var borderWidth: Int? = null
    private var callbacksScope: TooltipCallbacksScope? = null

    fun callbacks(block: TooltipCallbacksScope.() -> Unit) {
        callbacksScope = TooltipCallbacksScope().apply(block)
    }

    internal fun build() = TooltipOptions(
        enabled = enabled,
        mode = mode,
        intersect = intersect,
        backgroundColor = tooltipBackgroundColor,
        titleColor = titleColor,
        bodyColor = bodyColor,
        borderColor = borderColor,
        borderWidth = borderWidth,
        callbacks = callbacksScope?.build(),
    )
}
